/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineIdStatus202,
  PatchApiV1ClassroomdisciplineIdStatus400,
  PatchApiV1ClassroomdisciplineIdStatus401,
  PatchApiV1ClassroomdisciplineIdStatus404,
  PatchApiV1ClassroomdisciplineIdStatusMutationRequest,
  PatchApiV1ClassroomdisciplineIdStatusMutationResponse,
  PatchApiV1ClassroomdisciplineIdStatusPathParams,
} from "../../types/classPlanningController/PatchApiV1ClassroomdisciplineIdStatus.ts";
import { changeStatusRequestViewModelSchema } from "../changeStatusRequestViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineIdStatusPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatusPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ClassroomdisciplineIdStatus202Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ClassroomdisciplineIdStatus400Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineIdStatus401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ClassroomdisciplineIdStatus404Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatus404>;

export const patchApiV1ClassroomdisciplineIdStatusMutationRequestSchema =
  z.lazy(
    () => changeStatusRequestViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatusMutationRequest>;

export const patchApiV1ClassroomdisciplineIdStatusMutationResponseSchema =
  z.lazy(
    () => patchApiV1ClassroomdisciplineIdStatus202Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdStatusMutationResponse>;
